import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Navigation from "./Navigation";

import { css } from "@emotion/css";
import { MaximizerProvider } from "../../contexts/MaximizerContext";

const appStyle = css`
  display: grid;
  height: 100vh;
  font-size: 0.875em;
  color: var(--main-bg-color, gray);
  align-items: stretch;
  grid-template-columns: 100%;
  grid-template-rows: 50px 40px auto 72px;
  grid-template-areas:
    "header"
    "navigation"
    "main"
    "footer";
  min-height: 0;
  min-width: 0;
  max-width: 100%;

  & header {
    grid-area: header;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    &:last-child {
      align-self: end;
    }
    & h1 {
      flex-grow: 1;
    }
  }

  & nav {
    grid-area: navigation;
  }

  & main {
    grid-area: main;
    padding: 0 16px;
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;

    & > * {
      grid-row: 1;
      grid-column: 1;
    }

    & .content {
      width: 100%;
    }

    & > [data-state="open"] ~ .content {
      pointer-events: none;
      visibility: hidden;
      opacity: 0;
    }
  }

  & footer {
    grid-area: footer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px;
  }

  & footer[hidden] {
    display: none;
  }
`;

const skipLinkStyle = css`
  position: absolute;
  left: -9999px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: 1000;
  padding: 8px 16px;
  background: #000;
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  &:focus {
    position: fixed;
    top: 0;
    left: 0;
    width: auto;
    height: auto;
    overflow: visible;
  }
`;

const AppShell: React.FunctionComponent = (props: any) => {
  return (
    <MaximizerProvider>
      <div className={appStyle}>
        <a className={skipLinkStyle} href="#main">
          Skip to main content
        </a>
        <Header />
        <Navigation />
        <main id="main" tabIndex={-1}>
          {props.children}
        </main>
        <Footer />
      </div>
    </MaximizerProvider>
  );
};

export default AppShell;
